import { render, staticRenderFns } from "./UploadJDModal.vue?vue&type=template&id=38aa8356&scoped=true&"
import script from "./UploadJDModal.vue?vue&type=script&lang=js&"
export * from "./UploadJDModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadJDModal.vue?vue&type=style&index=0&id=38aa8356&scoped=true&lang=css&"
import style1 from "./UploadJDModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aa8356",
  null
  
)

export default component.exports